import { type BaseTemplateProps } from '../NotificationTemplate'
import { type TemplateDefinition } from '../TemplateRegistry'

interface ArConnectApiKeyAddedCancelNotifyFollowersProps extends BaseTemplateProps {
  request: {
    name: string
  }
}

export const ArConnectApiKeyAddedCancelNotifyFollowers: TemplateDefinition<ArConnectApiKeyAddedCancelNotifyFollowersProps> =
  {
    renderParams: (props: ArConnectApiKeyAddedCancelNotifyFollowersProps) => ({
      messageKey: 'notificationsDomain.templates.arConnectApiKeyAddedCancelNotifyFollowers',
      values: {
        apiKeyName: props?.request?.name,
      },
    }),
  }
